import React from "react";
import { jsx } from "slate-hyperscript";
import { BlockHandler, ElementType } from "./base";

BlockHandler.register(ElementType.ORDERED_LIST, {
    nodeTypes: ["OL"],
    toBlock: child => <ol>{child}</ol>,
    serialize: child => `<ol>${child}</ol>`,
    deserialize: children => jsx("element", { type: ElementType.ORDERED_LIST }, children),

});
